if (!customElements.get('lq-product-video-reels')) {
  customElements.define(
    'lq-product-video-reels',
    class ProductVideoReels extends HTMLElement {
      #controller = new AbortController();

      connectedCallback() {
        const videos = [...this.querySelectorAll('video')];
        const slides = [...this.querySelectorAll('[data-video-slide]')];

        for (const slide of slides) {
          const video = slide.querySelector('video');
          const playButton = slide.querySelector('[data-video-play]');

          if (!video || !playButton) continue;

          playButton.addEventListener(
            'click',
            async () => {
              try {
                await video.play();
              } catch {
                playButton.hidden = false;
              }
            },
            { signal: this.#controller.signal },
          );

          video.addEventListener(
            'play',
            () => {
              playButton.hidden = true;

              for (const otherVideo of videos) {
                if (otherVideo !== video) otherVideo.pause();
              }
            },
            { signal: this.#controller.signal },
          );

          video.addEventListener('pause', () => (playButton.hidden = false), {
            signal: this.#controller.signal,
          });
          video.addEventListener('ended', () => (playButton.hidden = false), {
            signal: this.#controller.signal,
          });
        }
      }

      disconnectedCallback() {
        this.#controller.abort();
      }
    },
  );
}

